import { render, staticRenderFns } from "./EditionContainer.vue?vue&type=template&id=2801f035&scoped=true"
import script from "./EditionContainer.vue?vue&type=script&lang=js"
export * from "./EditionContainer.vue?vue&type=script&lang=js"
import style0 from "./EditionContainer.vue?vue&type=style&index=0&id=2801f035&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2801f035",
  null
  
)

export default component.exports